import { ProjectStatus, ProjectStatuses } from '../../common/constants'

export type JobWorkarea = {
  id: number
  name: string | null
  status: ProjectStatus | null
  isOnHold: boolean
  completedDateUtc: string | null
}

/* Mirrors Project.TasksStatus on the server, which is what actually decides the column a
   ticket or maintenance job lands in. Duplicated here only to show the outcome before the
   user commits — the server stays the authority. */
export const rolledUpStatus = (workareas: JobWorkarea[]): ProjectStatus | null => {
  const counted = workareas.filter(workarea => !workarea.isOnHold)
  if (counted.length === 0) {
    return null
  }
  if (counted.every(workarea => workarea.status === ProjectStatuses.Completed)) {
    return ProjectStatuses.Completed
  }
  if (counted.some(workarea => workarea.status === ProjectStatuses.WaitingOnParts)) {
    return ProjectStatuses.WaitingOnParts
  }
  if (counted.some(workarea => workarea.status === null || workarea.status === ProjectStatuses.Unscheduled)) {
    return ProjectStatuses.Unscheduled
  }
  return ProjectStatuses.Scheduled
}

export const statusAfterSetting = (
  workareas: JobWorkarea[],
  selectedIds: number[],
  status: ProjectStatus
): ProjectStatus | null => {
  const selected = new Set(selectedIds)
  return rolledUpStatus(workareas.map(workarea =>
    selected.has(workarea.id) ? { ...workarea, status } : workarea))
}

export const selectableWorkareas = (workareas: JobWorkarea[]) =>
  workareas.filter(workarea => !workarea.isOnHold)

/* On-hold work areas are excluded from the rollup, so setting one cannot move the card and
   selecting it by default would misrepresent what the drop does. */
export const defaultSelection = (workareas: JobWorkarea[]) =>
  selectableWorkareas(workareas).map(workarea => workarea.id)

export const missesTheTarget = (
  workareas: JobWorkarea[],
  selectedIds: number[],
  status: ProjectStatus
) => selectedIds.length > 0 && statusAfterSetting(workareas, selectedIds, status) !== status
